module.exports = __webpack_public_path__ + "530aac4d308489c0a6e93419be29b510.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/new-realisations/xyz/city-walk/02.jpg
// module id = +IW6
// module chunks = 0